import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Modal, Row, Col, Button, Spinner } from "react-bootstrap";
import { Icon } from '@iconify/react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput, 
  ConversationHeader,
  MessageSeparator
} from '@chatscope/chat-ui-kit-react';
import _ from 'lodash';

import React from "react";

import APICom from "../../utils/helpers/APICom.js";
import ITCLogo from '../../assets/Images/CommonImages/ITC_Logo_White.png';
import ClearFilterIcon from '../../assets/Images/CommonImages/clearFilter.png';
import PersistStorage from "../../utils/helpers/PersistStorage.js";
import MultiSelectDropdown from "./multiselectdropdown.js";
import DateTimeUtils from "../../utils/DateTimeUtility.js";
import GridControl from "./gridControl.js";
import { all } from "axios";

const Messaging = (props) => {

  const DRIVERMSGTIMER = 500;
  
  const { ASCSSettingData, AffiliateData, AttributeData, RCZZoneVerticesData, ZoneVerticesData, isLoading, GlobalASCSData } = useSelector((store) => store.combinedata);
  const { loginData }  = useSelector((store) => store.login);

  const [sendMsgOptionsFlag, setSendMsgOptionsFlag] = useState({popup: false, voice: false});
  const [driverStatusFlag, setDriverStatusFlag] = useState('Active');
  const [driversBlockList, setDriversBlockList] = useState([]);
  const [affiliateDropDownHTML, setAffiliateDropDownHTML] = useState(null);
  const [selectedAff, setSelectedAff] = useState(()=>{
    const passedAff = PersistStorage.retrieve('passedAff', true);
    return (passedAff ? parseInt(passedAff) : AffiliateData[0].AffiliateID);
  });
  const [driverFilterInput, setDriverFilterInput] = useState('');
  const [createGroupFlag, setCreateGroupFlag] = useState(false);
  const [groupNameAssigned, setGroupNameAssigned] = useState('');
  const [dispatchMethod, setDispatchMethod] = useState(1);
  const [driverBlockListActiveCheck, setDriverBlockListActiveCheck] = useState([]);
  const [driverCardMsgList, setDriverCardMsgList] = useState([]);
  const [DriversFilterMultiSelect, SetDriversFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Driver(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Drivers", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [VehiclesFilterMultiSelect, SetVehiclesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Vehicle(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Vehicles", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [ZonesFilterMultiSelect, SetZonesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Zone(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Zones", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Attributes",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Attributes", SelectAllPlaceHolder:"",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [multiSelectValuesSelected, setMultiSelectValuesSelected] = useState({drivers: [], vehicles: [], zones: [], attributes: []});
  const [chatType, setChatType] = useState('chat');
  const [givenDateRange, setGivenDateRange] = useState('today');
  const [activeVehNo, setActiveVehNo] = useState(null);
  const [groupByFilter, setGroupByFilter] = useState('Drivers');
  const [showPopup, setShowPopup] = useState({show: false, groupDict: {}});
  const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });
  const [popupDriversList, setPopupDriversList] = useState([]);
  const [calendarMinMax, setCalendarMinMax] = useState({min: '', max: '', selected: ""});
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPos, setCalendarPos] = useState({ top: 0, left: 0 });
  const [openMsgScheduleView, setOpenMsgScheduleView] = useState(false);
  const [showAddScheduleDisplay, setShowAddScheduleDisplay] = useState(false);
  const [MsgSchGridOptions, setMsgSchGridOptions] = useState({
      height: 320,
      heightoffset: 600,
      calculateHeight: false,
      pagination: true,
      sortCondition: true,
      paginationSize: 5,
      paginationSizeSelector: [5, 10, 15, 20, 25],
      selectable: 1,
      reactiveData:false, //enable data reactivity
      layout: "fitDataStretch",
      placeholder:"No Data Available",
      clipboard: false,
      selectableRangeMode: "click",
      GridName:"MsgSchGrid",
      paginationCounter:"rows",
      intervalTimer: 0,
      movableColumns:true,
      vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
      index: "iID",
      autoColumns: true,
      bSysUser: 1,
      intervalEnable: false,
      persistence: false,
      bWebApplySettingToAll: true,
      GridReturnOnlyIDColumnInRowData: false,
      containerClass: "col position-relative",
      Containerstyle: {},
      footerElement: '<button class="tabulator_btns raised-button border border-dark me-2 " '
      +' title="Clear Filters" id="'+"MsgSchGrid"+'_ClearFilters"></button>',
      tableDoubleClickFunc: function(table, row) {

      },
      footerElementHandles: function (table) {
        msgSchGridRef.current = table;
        
        let img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ClearFilterIcon;
          document.getElementById("MsgSchGrid_ClearFilters").appendChild(img);
        document.getElementById('MsgSchGrid_ClearFilters').addEventListener("click", function(){
          table.clearHeaderFilter();
        });
      },
      rowSelectionChangeHandle: function (data) {  
        try{
          
        }
        catch(err){console.log(err);}
      },
      ActionList: false,
      AlwaysHiddenColumns: []
  });
  const [showLoader, setShowLoader] = useState(false);
  const [msgSchGridData, setMsgSchGridData] = useState([{"Schedule Name": '', "Created Date": '', 'Modified Date': '', 'Created By ID': '', 'Active': '', 'IsRecurring': '', 'iID': -1, 'AffiliateID': ''}]);
  const [addSchToggleOptions, setAddSchToggleOptions] = useState({recurring: false, popup: false, active: true});
  const [createSchDetails, setCreateSchDetails] = useState({name: '', time: '', extra: '', days: {mon: false, tue: false, wed: false, thurs: false, fri: false, sat: false, sun: false}});

  const [specialMsgDetails, setSpecialMsgDetails] = useState({title:'', body: '', option: 'OK'});
  const [blinkRecentMsg, setBlinkRecentMsg] = useState('');
  const [warningMsg, setWarningMsg] = useState('');

  const dateChanged= useRef(0);
  const activeDriver = useRef(null);
  const allMsgToDriverFlag = useRef(null);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [docTitle, setDocTitle] = useState("Messaging 2.0");


  const xCancelSourceForGrid = useRef(null);
  const loadSmartDevicesRef = useRef(0);
  const loadDriverMsgRef = useRef(0);
  const groupNameFieldRef = useRef(null);
  const driverCardRef = useRef([]);
  const dateRangeFromRef = useRef('Yesterday');
  const msgIDRecordDict = useRef({lastMsgID: '-1', NewMessageAlertLastMsgID: '-1', deviceRefNum: '-1'});
  const msgIDRef = useRef(-1);
  const globalInLoadAPIURL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : ""));
  const indexRef = useRef(0);
  const driverSearchFilterIntervalRef = useRef(null);
  const pageLoadRef = useRef(true);
  const dispatcherSend = useRef(false);
  const driverFilterInputRef = useRef('');
  const messageInputRef = useRef(null);
  const spanPopupRef = useRef([]);
  const dateSelectRef = useRef(null);
  const calendarSpanRef = useRef(null);
  const calendarInputRef = useRef(null);
  const msgSchGridRef = useRef(null);
  const msgListRef = useRef(null);
  const WebMRMS_URL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "WebMRMSURL") ? GlobalASCSData.find(dict => dict.SubTitle === "WebMRMSURL").value : ""));
  const [scheduleDialog, setScheduleDialog] = useState({Display:false, URL: "", isLoading: true });

  let senderColorMap = new Map();
  if (driverCardMsgList && driverCardMsgList.msgList && driverCardMsgList.msgList.length > 0) {
    const uniqueSenders = [...new Set(driverCardMsgList.msgList.map(item => item.msgFrom))];
    const generateColor = (index) => {
      const hue = (index * 137.508) % 360;
      return `hsl(${hue}, 70%, 80%)`;
    };

    uniqueSenders.forEach((sender, index) => {
      senderColorMap.set(sender, generateColor(index));
    });
  }

  const filterOptionsMap = {
    Drivers: {
      options: DriversFilterMultiSelect,
      setOptions: SetDriversFilterMultiSelect
    },
    Vehicles: {
      options: VehiclesFilterMultiSelect,
      setOptions: SetVehiclesFilterMultiSelect
    },
    Zones: {
      options: ZonesFilterMultiSelect,
      setOptions: SetZonesFilterMultiSelect
    },
    Attributes: {
      options: AttributesFilterMultiSelect,
      setOptions: SetAttributesFilterMultiSelect
    }
  };
  
  
  /**
   * Loads necessary data on page load. e.g. affiliate info, user login info, 
   * calls for load of vehicle devices like MDT and PIM
   */
  useEffect(() => {
    try{
      //ADDED FOR REMOVAL OF SPECIAL CHAT OPTIONS
      setChatType('chat'); 
      setSpecialMsgDetails({title:'', body: '', option: 'OK'});
      document.title = docTitle;
      let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
      let affiliateOptionsHTML = AffiliateData.map(function(item, index){ //filtering only affiliates that the user has access to
        if(loginUserAffiliateList.includes(String(item.AffiliateID)))
        {
          return (
            <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
          );
        }
      });
      
      let resizeTimer = 0;
      //Sets the dispatch method based on affiliate, if it exists in ASCS setting
      setDispatchMethod((selectedAff && selectedAff !== '' && ASCSSettingData[selectedAff] ? 
        (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "DispatchMethod").value) : 1));

      setAffiliateDropDownHTML(affiliateOptionsHTML);
      
      loadSmartDevices();

      // Initial center
      centerSelect();

      //End of an initial loading phase.
      setTimeout(() => {
        pageLoadRef.current = false;
      }, 500);

      function centerSelect() {
        try{
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            const container = msgListRef.current;
            const select = dateSelectRef.current;
            if (container && select) {
              const right = (container.clientWidth - select.offsetWidth) / 2;

              select.style.right = `${right}px`;
            }
          }, 100);
        } catch(err) {console.log(err);}
      }

      window.addEventListener('resize', centerSelect);
      
      return () => {
        window.removeEventListener('resize', centerSelect);
        clearTimeout(loadSmartDevicesRef.current);
        clearTimeout(loadDriverMsgRef.current);
      };

    } catch(err){console.log(err);}

    
  }, []);

  useEffect(() => {

    setDriversBlockList(prev=>prev.map((item, i) => {
      const storedMsg = localStorage.getItem(`DriverMsg_${item.driverNo}`);
      if(storedMsg !== null){
        
        //setBlinkRecentMsg(((dispatcherSend.current ? item.name + " ➥ " + item.name + " (" + item.driverNo + "): " : item.name + " (" + item.driverNo + "): ") + storedMsg.msgString));
      
        dispatcherSend.current = false;
        return {...item, blink: true};
      
      }
      else{
        return item;
      }
    }));

   
  }, [activeVehNo])

  useEffect(() => {
    document.title = docTitle;
  }, [docTitle])

  /**
   * changes dispatch method and loads smart devices when affiliate is changed
   */
  useEffect(()=>{
    try{
      if(selectedAff && loadSmartDevicesRef.current){
        setMessagesLoading(true);
        clearTimeout(loadSmartDevicesRef.current);

        setDriverCardMsgList([]); // Immediately clear the message list from the UI
        setActiveVehNo('XXXX'); 
        activeDriver.current = "BroadCast" 

        //Sets the DispatchMethod from ASCSSettingData for the selected affiliate
        setDispatchMethod((selectedAff && selectedAff !== '' && ASCSSettingData[selectedAff] ? 
          (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "DispatchMethod").value) : 1));
        loadSmartDevices('first');
        
      }
    }
    catch(err){console.log(err); setMessagesLoading(false);}
  }, [selectedAff]);


  /**
   * fetches driver messages when a new driver block is active
   */
  useEffect(()=>{
    try{
      if(driverBlockListActiveCheck.length > 0 && msgIDRef.current > -1){
        handleGetDriverMsg(msgIDRef.current);
        msgIDRef.current = -1;
      }

    } catch(err){console.log(err);}
  }, [driverBlockListActiveCheck]);


  /**
   * stops the blinking for a new message?
   */
  useEffect(()=>{
    try{
      if(driversBlockList.length > 0){
        const driverWithBlink = driversBlockList.find(card => card.blink);
        if(!driverWithBlink){setBlinkRecentMsg(''); setDocTitle("Messaging 2.0");}
      }

    } catch(err){console.log(err);}
  }, [driversBlockList]);


  /**
   * handles the change in active vehicle
   */
  useEffect(() => {
    try{
      if(activeVehNo){
        //removes the message from local storage, and checks if any cards are blinking
        localStorage.removeItem(`DriverMsg_${activeVehNo}`);
        

        setDriversBlockList(prev=> prev.map((val, i)=>({
            ...val,
            blink: (i === (indexRef.current) ? false : val.blink)
          }))
        );
        if(!pageLoadRef.current){
          handleGetDriverMsg(indexRef.current, 'first'); //If the page has already finished loading, immediately loads the first message for the selected driver
        }

        const driverWithBlink = driversBlockList.find(card => card.blink && card.driverNo !== activeVehNo);
        //if no cards are blinking, removes the notification icon from the d2.0 header
        if(!driverWithBlink){localStorage.setItem("notifIcon", false)}
      }
      else{
        
        msgIDRecordDict.current.lastMsgID = -1;
        setTimeout(() => {
          if(driversBlockList.length > 0 && driversBlockList[(indexRef.current)].blink){
            // setBlinkRecentMsg('');
            setDriversBlockList(prev=>prev.map((val, i)=>({
                ...val,
                blink: (i === (indexRef.current) ? false : val.blink)
              }))
            );

            const driverWithBlink = driversBlockList.find(card => card.blink && card.driverNo !== activeVehNo);
            //if no cards are blinking, removes the notification icon from the d2.0 header
            if(!driverWithBlink){localStorage.setItem("notifIcon", false)}

          }
          
          if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
          
          setDriverCardMsgList([]);
        }, 500);
      }
    } catch(err){console.log(err);}
  }, [activeVehNo]);


  /**
   * triggers a delated device refresh
   */
  useEffect(() => {
    try{
      if(!pageLoadRef.current){
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        loadSmartDevices('later');
      }

    } catch(err){console.log(err);}
  }, [driverStatusFlag, allMsgToDriverFlag.current]);


  useEffect(() => {
    try{
      if(calendarMinMax.selected !== '' && warningMsg === ''){
        if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
        loadDriverMsgRef.current = setTimeout(async () => {
          await handleGetDriverMsg(0, 'second');
        }, DRIVERMSGTIMER);
      }
    } catch(err){console.log(err);}
  }, [calendarMinMax]);

  /**
   * Resets the calendar selection and date range to the default state.
   */
  function resetCalendar () {
    try{
      setShowCalendar(false); setGivenDateRange('today'); 
      dateRangeFromRef.current = 'today';
      setCalendarMinMax(prev=>({...prev, selected: ''}));

    } catch(err){console.log(err);}
  }

   
/**
 * Handles sending a message to a device(s) or group(s)
 * @param {string} msg The message to be sent
 * @returns {Promise<void>} A promise that resolves when the message has been sent
 */
  async function handleMsgSent (msg) {
    try{
      if(msg && msg.trim() !== '' && driverBlockListActiveCheck.length > 0){
        let deviceNo = '';
        let vehNo = '';
        let isGroup = false;
        
        const currentDriver = driverBlockListActiveCheck[parseInt(indexRef.current)];
        if(currentDriver){
          deviceNo = currentDriver.deviceID;
          vehNo = currentDriver.vehNo;
          isGroup = currentDriver.group !== '-1';
        }
        msg = msg.replace(/<br\s*[\/]?>/gi, "\n");
        let data = (isGroup && !deviceNo.includes('X')? 
          {
            "ATSPID": parseInt(selectedAff),
            "iGroupID" : parseInt(deviceNo),
            "UserID": String(loginData.iUserID),
            "UserName" : String(loginData.vUserName),
            "Message": String(msg).replace(/(&nbsp;)/gi, ''),
            "IsPowerUser": loginData.IsPowerUser,
          }
          :
          {
            "DeviceNo": String(deviceNo),
            "Message": String(msg).replace(/(&nbsp;)/gi, ''),
            "VoiceMessage": sendMsgOptionsFlag.voice,
            "PopupMessage": sendMsgOptionsFlag.popup,
            "VehicleNo": String(vehNo),
            "ATSPID": parseInt(selectedAff),
            "UserID": String(loginData.iUserID),
            "UserName": String(loginData.vUserName),
            "IsPowerUser": loginData.IsPowerUser,
          }
        );
        const inloadSendMsgURL = globalInLoadAPIURL.current + (isGroup && !deviceNo.includes('X') ? "/Message/SendGroupMessageToDevices" : "/Message/SendMessageToDevice");
        await APICom.fetchData('full', inloadSendMsgURL, "post", { "Content-Type": "application/json" }, data, null);
        dispatcherSend.current = true;
        
      }

    } catch(err) {console.log(err);}
  }


  /**
   * Prepares and sends an API request to delete a group
   * @param {*} groupDict Dictionary containing the group to be deleted
   */
  async function deleteSelectedGroup (groupDict) {
    try{
      let data = {
        "ATSPID": parseInt(selectedAff),
        "GroupID": parseInt(groupDict.deviceID),
      };
      const removeResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/DeleteMessagingGroup", "post", { "Content-Type": "application/json" }, data, null);
      //reloads the smart devices once deletion is confirmed
      if(removeResp && removeResp.error.length === 0){
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        await loadSmartDevices();
      }

    } catch(err){console.log(err);}
  }

  async function editSelectedGroup (groupDict) {
    try{
      console.log("edit clicked");

    }
    catch(err){console.log(err);}
  }

  /**
   * Filters the driver list and polls it every 300ms
   * This logic ensures the backend is only hit after the user stops typing for >= timeInterval
   * @param {*} e Event value holding filter criteria (String)
   */  
  function handleFilterDrivers (e) {
    try{
      let elapsedTime = 0;
      const timeInterval = 300;
      const trimmedInput = e.target.value.trim();
      let lastInput = trimmedInput;
      setDriverFilterInput(e.target.value);
      if(driverSearchFilterIntervalRef.current){clearInterval(driverSearchFilterIntervalRef.current);}

      //Starts a polling loop every 200ms to check if the input has remained unchanged for a full debounce cycle.
      driverSearchFilterIntervalRef.current = setInterval(async () => {
        try{
          if(lastInput === driverFilterInput.trim()){
            //No change occured
            elapsedTime += 100;
          }
          else
          {
            //A change occured, reduce timer 100ms
            lastInput = driverFilterInput.trim();
            elapsedTime = 0;
          }
          if(elapsedTime >= timeInterval) //stable input
          {
            clearInterval(driverSearchFilterIntervalRef.current);
            if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
            driverFilterInputRef.current = trimmedInput;
            await loadSmartDevices('later');
          }
        }
        catch(err){console.log(err); clearInterval(driverSearchFilterIntervalRef.current);}
      }, timeInterval);
      
      
    }
    catch(err) {console.log(err);}
  }


  /**
   * Creates a group of drivers
   * I don't really see how these persist? 
   * @param {*} e Event value holding name for group? 
   */
  async function addGroupOfDrivers (e) {
    try{
      //if valid group, reloads smart devices
      if(groupNameAssigned && groupNameAssigned.trim() !== ''){
        const IDs = multiSelectValuesSelected[(groupByFilter.toLowerCase())];
        let data = {
          "atspid": parseInt(selectedAff),
          "dispatcherUserID": String(loginData.iUserID),
          "groupName": groupNameAssigned,
          "mode": String(groupByFilter),
          "driverIDs": String(IDs)
        };
        // WHERE have my groups gone? 
        const addGroupResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/CreateMessagingGroup", "post", { "Content-Type": "application/json" }, data, null);
        if(addGroupResp.error.length > 0){
          //unfinished
        }
        setCreateGroupFlag(false);
        loadSmartDevices();
      }
      else
      {
        //flashing error for invalid name
        groupNameFieldRef.current.style.border = "2px solid red";
        setTimeout(() => {
          if(groupNameFieldRef.current){
            groupNameFieldRef.current.focus();
            groupNameFieldRef.current.style.borderColor = '';
            groupNameFieldRef.current.style.borderWidth = '';
          }
        }, 1000);
      }

    } catch (err) {console.log(err);}
  }


  /**
   * Loads the list of "smart devices"
   * Populates drop down too? 
   * @param {*} occurance = 'first' = Initializes the broadcast device’s vehicle number via setActiveVehNo(...)
   * @param {*} occurance = Skips setting the active vehicle and resets the message index (msgIDRef.current = -1)
   */
  async function loadSmartDevices (occurance = 'first') {
    try{
      let data = {
        atspid: (selectedAff ? parseInt(selectedAff) : -1),
        showDriver: true,
        dispatcherUserID: String(loginData.iUserID)
      };
      let filteredSortedDataArr = [];
      xCancelSourceForGrid.current = APICom.GenerateSource(); //Cancel token if needed
      //API call
      const loadDeviceResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadSmartDevices", "post", {}, data, xCancelSourceForGrid.current);
      const respDataArr = loadDeviceResponse.data;
      const devicesArr = [];
      const driversArr = [];
      const vehiclesArr = [];
      const inputFilter = driverFilterInputRef.current;
      if(loadDeviceResponse && loadDeviceResponse.error.length === 0 && (respDataArr && Array.isArray(respDataArr) && respDataArr.length > 0)){
        for(let k = 0; k < respDataArr.length; k++) //iterates through all device records in response
        {
          if(respDataArr[k].DeviceID === 'XXXX' && respDataArr[k].DisplayString === 'Broad Cast')
          {
            if(occurance === 'first'){
              setActiveVehNo(respDataArr[k].VehNum);
              msgIDRef.current = k;
              indexRef.current = k;
            }
            else {
              msgIDRef.current = -1;
            }
            //Pushes a special "BroadCast" card to devicesArr
            devicesArr.push({name: 'BroadCast', id: -1, driverNo: respDataArr[k].DriverNum, vehID: -1, vehNo:respDataArr[k].VehNum, deviceID: respDataArr[k].DeviceID, 
              active:false, activeDriver:'N/A', group:'Broad', msgList: respDataArr[k].sdMessageList, blink: false, vehType: respDataArr[k].VehicleType
            });
          }
          else if(respDataArr[k].DriverNum === 'XXXX'){
            devicesArr.push({name: respDataArr[k].DisplayString, id: -1, driverNo: respDataArr[k].DriverNum, vehID: -1, 
              vehNo:respDataArr[k].VehNum+"_"+respDataArr[k].DisplayString, deviceID: respDataArr[k].DeviceID, 
              active:false, activeDriver:'N/A', group:respDataArr[k].DisplayString, msgList: respDataArr[k].sdMessageList, blink: false, vehType: respDataArr[k].VehicleType
            });
          }
          else { //Separates driver/vehicle info and builds full device entries 
            driversArr.push({name: respDataArr[k].DriverName, id: respDataArr[k].DriverID, number: respDataArr[k].DriverNum});
            vehiclesArr.push({vehNum: respDataArr[k].VehNum, vehID: respDataArr[k].VehicleID});
            let isActive = (respDataArr[k].ImageKey.toLowerCase().includes('online') || respDataArr[k].ImageKey.toLowerCase().includes('newbusy') ? true : false);
            devicesArr.push({name: respDataArr[k].DriverName, id: respDataArr[k].DriverID, driverNo: respDataArr[k].DriverNum,
              vehID: respDataArr[k].VehicleID, vehNo:respDataArr[k].VehNum,  deviceID:respDataArr[k].DeviceID, 
              active:false, activeDriver:isActive, group:'-1', msgList: respDataArr[k].sdMessageList, blink: localStorage.getItem(`DriverMsg_${respDataArr[k].VehNum}`) ? true : false, vehType: respDataArr[k].VehicleType
            });
          }
        }

        //Filters devices by 
        //Online/Offline status (driverStatusFlag)
        //Matches (name, driverNo, vehNo)
        filteredSortedDataArr = devicesArr.filter((person) => (
          person.group !== '-1' ||
          (
            ((driverStatusFlag === 'Active' && person.activeDriver) || 
            (driverStatusFlag !== 'Active' && !person.activeDriver)) &&
            (
              person.name.toLowerCase().includes(inputFilter.trim().toLowerCase()) ||
              person.driverNo.includes(inputFilter.trim()) ||
              person.vehNo.includes(inputFilter.trim())
            )
          )
        ))
        .sort((a, b) => {
          const aIsBroadcast = a.name === 'BroadCast';
          const bIsBroadcast = b.name === 'BroadCast';
          if (aIsBroadcast && !bIsBroadcast) return -1;
          if (!aIsBroadcast && bIsBroadcast) return 1;
          const AisGrouped = a.group !== '-1';
          const BisGrouped = b.group !== '-1';
          if (AisGrouped !== BisGrouped) {
            return AisGrouped ? -1 : 1;
          }
          return a.name.localeCompare(b.name);
        });

        //Updates the state/UI if the filtered list is different
        if(!_.isEqual(driverCardRef.current, filteredSortedDataArr)){
          populateDropdowns(driversArr, vehiclesArr); //updates dropdowns
          driverCardRef.current = [...filteredSortedDataArr]; //Stores filtered list in reference
          //Updates display and active-check lists
          setDriversBlockList(filteredSortedDataArr);
          setDriverBlockListActiveCheck(filteredSortedDataArr);

        }
        //Schedules the next refresh
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        loadSmartDevicesRef.current = setTimeout(async () => {
          await loadSmartDevices('later');
        }, 10500);
      }

    } catch(err) {console.log(err);}
  }


  /**
   * Refreshes, sorts, and populates the needed arrays for the drop downs
   * @param {*} driversArr Array of driver objects
   * @param {*} vehiclesArr Array of vehicle objects
   */
  function populateDropdowns (driversArr = [], vehiclesArr = []) {
    try{
      //Finds the slected affiliate and loads the correct dataset
      const AffiliateDetails = AffiliateData.find(item => parseInt(item.AffiliateID) === parseInt(selectedAff));
      //Finds zones
      const zones = (AffiliateDetails ? (parseInt(AffiliateDetails.iTransType) === 2 ? 
        ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table) 
        : []
      );

      //deduplicates drivers
      
      const uniqueDriversArr = driversArr.filter((driver =>{
        const seen = new Set();
        return driver => {
          if(seen.has(driver.name)){ return false;}
          seen.add(driver.name);
          return true;
        };
      })()); 
      
      //Filters and sorts attribute options relevant to the current affiliate.
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(selectedAff)}) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];

      //sorts drivers
      let driverOptionsMultiSel = uniqueDriversArr.length > 0 ? uniqueDriversArr.map((item)=>{
        let dict = {};
        dict.id = item.id;
        dict.name = item.number + " - " + item.name
        return dict;
      }).sort((a,b)=>{
        const numA = a.name ? parseInt(a.name.split(" - ")[0], 10) : null;
        const numB = b.name ? parseInt(b.name.split(" - ")[0], 10) : null;
        if (numA === null && numB === null) return 0;
        if (numA === null) return 1; // Push a to the end
        if (numB === null) return -1; // Push b to the end
        return numA - numB;
      }) : [];

      //Sorts vehicles
      let vehicleOptionsMultiSel = vehiclesArr.length > 0 ? vehiclesArr.map((item)=>{
        let dict = {};
        dict.id = item.vehID;
        dict.name = item.vehNum;
        return dict;
      }).sort((a,b) => {
        const numA = a.name ? parseInt(a.name, 10) : null;
        const numB = b.name ? parseInt(b.name, 10) : null;
        if (numA === null && numB === null) return 0;
        if (numA === null) return 1; // Push a to the end
        if (numB === null) return -1; // Push b to the end
        return numA - numB;
      }) : [];
      let zoneDict = {};
      let zonesArr = [];

      //Finds unique zones and sorts them
      for(const element of zones)
      {
        if(parseInt(element.iZVATSPID) === parseInt(selectedAff)) //props.selectedAffiliates
        {
          let key = element.vName;
          let dict = {};
          if(key in zoneDict)
          {
            let zoneLocations = zoneDict[key];
            let tempDict = {"lat": parseFloat(element.vLat), "lng": parseFloat(element.vLong)};
            zoneLocations.push(tempDict);
            zoneDict[key] = zoneLocations;
            dict.name = key.toUpperCase();
            dict.id = key.toUpperCase();
            zonesArr.push(dict);
          }
          else
          {
            let zoneLocations = [];
            let tempDict = {"lat": parseFloat(element.vLat), "lng": parseFloat(element.vLong)};
            zoneLocations.push(tempDict);
            zoneDict[key] = zoneLocations;
            dict.name = key.toUpperCase();
            dict.id = key.toUpperCase();
            zonesArr.push(dict);
          }
          
        }
      }

      //Updates 4 multi-select drop downs
      // - Drivers
      // - Vehicles
      // - Zones
      // - Attributes
      const uniqueZonesArr = Array.from(
        new Map(zonesArr.map(item=>[item.name, item])).values()
      );
      const sortedZonesOptionsMultiSel = uniqueZonesArr.sort((a,b)=>a.name.localeCompare(b.name));

      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{options: driverOptionsMultiSel,
        selectedValues:[]}}
      );
      SetVehiclesFilterMultiSelect({ ...VehiclesFilterMultiSelect, ...{options: vehicleOptionsMultiSel,
        selectedValues:[]}}
      );
      SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{options: sortedZonesOptionsMultiSel,
        selectedValues:[]}}
      );
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
        selectedValues:[]}}
      );

    } catch(err){console.log(err);}
  }


   /**
   * Handles selection changes for multi-select dropdowns.
   *
   * This callback updates both the selected values in the central state and the dropdown's UI state
   * when the user selects or deselects items in a multi-select dropdown.
   *
   * Args:
   *   selectedVals: Array of selected values from the dropdown.
   *   key: The string key to update in the central selection object (e.g., "drivers" or "attributes").
   *   multiSelDetails: Object containing dropdown metadata, including the full options list.
   *   multiSelDropdownSetter: setState function for updating the dropdown's UI state.
   *   multiSelChoiceUpdate: setState function for updating selected values in the central tracking state.
   */
  const GenericSelectCallback = (selectedVals, key = "", multiSelDetails = [], multiSelDropdownSetter, multiSelChoiceUpdate) => { //Multiselect attribute selection on change
    try{
      
      const stringVals = selectedVals.map((num) => num.toString()); //Convert selected values to string
      
      //Builds a groupSelected array of full objects with {id, name}
      let groupSelected = [];
      if(multiSelDetails.options) {
        for(const element of multiSelDetails.options)
        {
          if(stringVals.includes(String(element.id)))
          {
            groupSelected.push({id:element.id, name:element.name});
          }
        }
        
        //Stores selected IDs (as strings) in a key-value object
        multiSelChoiceUpdate(prev=>({...prev, [key]: stringVals})); 
        //updates the dropdown's internal state with the actual selected option objects
        multiSelDropdownSetter({ ...multiSelDetails, ...{ selectedValues: groupSelected}});
      }
    }
    catch(err){console.log(err);}
  };


  /**
   * Clears user input and selections for group filters
   */
  function clearGroupDetails () {
    try{
      setGroupNameAssigned(""); //Clears group name input field
      //Clears multi-select drop downs
      setMultiSelectValuesSelected({drivers: [], vehicles: [], zones: [], attributes: []}); 
      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetVehiclesFilterMultiSelect({ ...VehiclesFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{selectedValues:[]}}
      );
      loadSmartDevices();
    }
    catch(err){console.log(err); loadSmartDevices();}
  }


  /**
   * 
   */
  function handleSendSpecialMsg () {
    try{



    } catch(err){console.log(err);}
  }


  /**
   * 
   */
  function refreshSpecialMsgHistory () {
    try{



    } catch(err){console.log(err);}
  }

  /**
   * Handles getting messages back from drivers
   * @param {*} index Seems to be index of driver to get message from
   * @param {*} term No idea, seems to be used for method of refresh? First must be for initial page load? 
   */
  async function handleGetDriverMsg(index, term = 'first') {
    try{
      
      const actualIndex = parseInt(indexRef.current); 
      if(driverBlockListActiveCheck[actualIndex] === undefined)
        return;

      const driverNameForThisCall = driverBlockListActiveCheck[actualIndex].name;

      const toDateVal = 'now';
      let fromDateVal = '';
      let fetchLatestOnly = false;
      
      if(term === 'first'){
        setDriverBlockListActiveCheck(prev=>prev.map((driver, i)=>({
          ...driver,
          active: (i === actualIndex ? !driver.active : false),
        }))); 
        setGivenDateRange('today');
        dateRangeFromRef.current = 'today';
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        fromDateVal = 'today';
      }
      else {
        fromDateVal = dateRangeFromRef.current;
      }
      
      //Checks if message fetch should continue
      if(!driverBlockListActiveCheck[actualIndex].active || term !== 'first' || driverBlockListActiveCheck[actualIndex].deviceID  === 'XXXX'){

        //builds body data
        // const driverCardMsgID = (term === 'first' ? -1 : parseInt(msgIDRecordDict.current.lastMsgID));
        const deviceNumVal = String(driverBlockListActiveCheck[actualIndex].deviceID) + String(driverBlockListActiveCheck[actualIndex].driverNo);

        if(String(msgIDRecordDict.current.deviceRefNum) === deviceNumVal && dateChanged.current === 0){
          fetchLatestOnly = true;
        }
        else{
          setMessagesLoading(true);
          fetchLatestOnly = false;
          msgIDRecordDict.current.deviceRefNum = deviceNumVal;
        }
        let data = {
          atspid: parseInt(selectedAff),
          newMessagePopupLastMessID: parseInt(msgIDRecordDict.current.NewMessageAlertLastMsgID),
          driverID: ("@"+ driverBlockListActiveCheck[actualIndex].driverNo),
          vehicleID: String(driverBlockListActiveCheck[actualIndex].vehID),
          userID: (allMsgToDriverFlag.current === null || allMsgToDriverFlag.current === false)? 'LoginUser' : 'all',
          dispatcherUserID: String(loginData.iUserID),
          deviceID: String(driverBlockListActiveCheck[actualIndex].deviceID),
          toDate: toDateVal,
          fromDate: fromDateVal,
          tillDate: (fromDateVal.includes("jump") && calendarMinMax.selected !== '' ? new Date(calendarMinMax.selected + " 00:00:00") : new Date())
        };
        if(fetchLatestOnly && parseInt(msgIDRecordDict.current.lastMsgID) > 0)
        {
          data.lastMessID = (term === 'first' ? -1 : msgIDRecordDict.current.lastMsgID);
        }
        //Makes API post call
        xCancelSourceForGrid.current = APICom.GenerateSource();
        const loadMsgResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadGeneralMessages", "post", {}, data, xCancelSourceForGrid.current);
        //successful response
        if(loadMsgResponse && loadMsgResponse.error.length === 0 ) {
          dateChanged.current = 0;
          const lastIndex = (loadMsgResponse.data.length - 1);
          msgIDRecordDict.current.lastMsgID = parseInt(loadMsgResponse.data[lastIndex].MessageID) > -1 ? loadMsgResponse.data[lastIndex].MessageID : msgIDRecordDict.current.lastMsgID;
          if(parseInt(loadMsgResponse.data[0].NewMessageAlertLastMessID) > -1 && 
            loadMsgResponse.data[0].NewMessageAlertLastMessID !== msgIDRecordDict.current.NewMessageAlertLastMsgID
          )
          {
            msgIDRecordDict.current.NewMessageAlertLastMsgID = loadMsgResponse.data[0].NewMessageAlertLastMessID;
          }
          //Displays message and triggers blink notification
          if(loadMsgResponse.data[0].msgString !== '') {
            if(loadMsgResponse.data[0].NewMessageAlertVehNo && loadMsgResponse.data[0].NewMessageAlertVehNo !== ''){
              setDriversBlockList(prev=>prev.map((item, i) => {
                if(String(item.vehNo) === loadMsgResponse.data[0].NewMessageAlertVehNo){
                  setBlinkRecentMsg(((dispatcherSend.current ? loadMsgResponse.data[0].msgFrom + " ➥ " + item.name + " (" + item.driverNo + "): " : item.name + " (" + item.driverNo + "): ") + loadMsgResponse.data[0].msgString));
                  dispatcherSend.current = false;
                  setDocTitle(`Driver ${item.driverNo}: New Msg`);
                  return {...item, blink: (String(item.vehNo) === loadMsgResponse.data[0].NewMessageAlertVehNo && loadMsgResponse.data[0].NewMessageAlertVehNo !== activeVehNo)};
                }
                else{
                  setDocTitle("Messaging 2.0");
                  return item;
                }
              }));
              
            }
            if(parseInt(loadMsgResponse.data[0].MessageID) > -1){
                if(loadMsgResponse.data[0].msgString !== ''){
                  setTimeout(() => {
                    setDriverCardMsgList(prev=>{
                      if (activeDriver.current !== driverNameForThisCall){
                        return prev;
                      }

                      const isForSameDriver = driverNameForThisCall === prev.driverName;

                      const baseMsgList = isForSameDriver ? prev.msgList : [];

                      const existingMsgStrings = new Set(baseMsgList.map(m => `${m.msgString}|${m.msgTime}`));

                      const newMsg = loadMsgResponse.data.filter(
                        m => !existingMsgStrings.has(`${m.msgString}|${m.msgTime}`)
                    );

                      const oldMsg = [...existingMsgStrings].filter(
                        m => !loadMsgResponse.data.some(m2 => `${m2.msgString}|${m2.msgTime}` === m)
                    );
                    
                    
                      // If there are no new messages, return the previous state to avoid a re-render.
                      if (newMsg.length === 0 && oldMsg.length === 0) {
                        return prev;
                      }
                      else if (newMsg.length > 0) {
                        return {
                          driverName: driverNameForThisCall,
                          msgList: [...baseMsgList, ...newMsg].sort((a, b) => new Date(a.msgTime) - new Date(b.msgTime))
                        };
                      }
                      else if (oldMsg.length > 0) {                        
                        return{
                          driverName: driverNameForThisCall,
                          msgList: [...loadMsgResponse.data].sort((a, b) => new Date(a.msgTime) - new Date(b.msgTime))
                        }
                      }
                    });
                    
                  }, 0);
                }
            }
            if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
            loadDriverMsgRef.current = setTimeout(async () => {
              await handleGetDriverMsg(actualIndex, 'second');
            }, DRIVERMSGTIMER);
          }
          else{
            if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
            loadDriverMsgRef.current = setTimeout(async () => {
              await handleGetDriverMsg(actualIndex, 'second');
            }, DRIVERMSGTIMER);
          }
        }
        else
        { //Ensures no dangling polling timers and clears UI when no further fetch is required.
          if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
          msgIDRecordDict.current.lastMsgID = -1;
          setDriverCardMsgList([]);
          if(!driverBlockListActiveCheck[actualIndex].active){
            loadDriverMsgRef.current = setTimeout(async () => {
              await handleGetDriverMsg(actualIndex, 'second');
            }, DRIVERMSGTIMER);
          }
        }
      }
      else {
        if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
        setDriverCardMsgList([]);
      }
    } catch(err){console.log(err); setDriverCardMsgList([]);}
    finally{
        setMessagesLoading(false);
    }
  }

  async function handlePopupView (show, groupDetails, groupIndex = 0) {
    try{
      if(show){
        const spanElement = spanPopupRef.current[groupIndex];
        if(spanElement){
          xCancelSourceForGrid.current = APICom.GenerateSource();
          const rect = spanElement.getBoundingClientRect();
          
          const groupMembersData = {
            'ATSPID': parseInt(selectedAff),
            'GroupID': parseInt(groupDetails.deviceID)
          };
          const groupListResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadGroupDevicesList", "post", {}, groupMembersData, xCancelSourceForGrid.current);

          if(groupListResp && groupListResp.error.length === 0 && Array.isArray(groupListResp.data) && groupListResp.data.length > 0){
            setPopupDriversList(groupListResp.data);
          }
          setPopupPos({
            top: rect.top + 20,
            left: rect.right + window.scrollX
          });
          setShowPopup({show: true, groupDict: groupDetails});
        }
      }
      else{
        setPopupDriversList([]);
        setShowPopup({show: false, groupDict: {}});
        setPopupPos({ top: 0, left: 0 });
      }
    } catch (err) {console.log(err);}
  }

  async function handleDateRangeChange (e) {
    try{
      setMessagesLoading(true);
      const newDate = e.target.value;
      setGivenDateRange(newDate); 
      dateRangeFromRef.current = newDate;
      setDriverCardMsgList([]);
      if(newDate === 'jump to specific date')
      {
        const SystemDateTime = await DateTimeUtils.getCurrentSystemDateTime();
        const [month, day, year] = (SystemDateTime.split(" ")[0]?.split("/") || ['','','']);
        const systemDateFormatted = (month !== '' ? (year + "-" + month + "-" + day) : null);
        if(systemDateFormatted){
          const threeMonthBound = new Date(systemDateFormatted + " 00:00:00");
          threeMonthBound.setMonth(threeMonthBound.getMonth() - 3);
          const minDateFinal = threeMonthBound.toISOString().split('T')[0];
          const maxDateFinal = systemDateFormatted;
          const rect = dateSelectRef.current.getBoundingClientRect();
          setCalendarMinMax(prev=>({...prev, min: minDateFinal, max: maxDateFinal}));
          setCalendarPos({
            top: rect.top + 40,
            left: rect.right + window.scrollX - 160
          });
          setShowCalendar(true);
          setTimeout(() => {
            if(calendarInputRef.current){
              calendarInputRef.current.focus();
            }
          }, 200);

        }
        else{
          setShowCalendar(false);
        }
      }
      else{
        dateChanged.current = 1;
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        setShowCalendar(false);
        
      }
      
      
    } catch(err){console.log(err);}
  }

  function dateCheck(e, type = '') {
    try {
      const selectedDate = new Date(e.target.value + " 00:00:00");
      const minDate = new Date(calendarMinMax.min + " 00:00:00");
      const maxDate = new Date(calendarMinMax.max + " 00:00:00");
      const minDateForm = `${String(minDate.getMonth() + 1).padStart(2, '0')}/${String(minDate.getDate()).padStart(2, '0')}/${minDate.getFullYear()}`;
      const maxDateForm = `${String(maxDate.getMonth() + 1).padStart(2, '0')}/${String(maxDate.getDate()).padStart(2, '0')}/${maxDate.getFullYear()}`;
      if(selectedDate > maxDate){
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        if(calendarInputRef.current){
          calendarInputRef.current.style.border = '2px solid red';
        }
        setWarningMsg(<p className="m-0 small fw-normal">{'Min: ' + minDateForm} <br/> {'Max: ' + maxDateForm}</p>)
      }
      else if(selectedDate < minDate){
        //setCalendarMinMax(prev=>({...prev, selected: ''}));
        if(calendarInputRef.current){
          calendarInputRef.current.style.border = '2px solid red';
        }
        setWarningMsg(<p className="m-0 small fw-normal">{'Min: ' + minDateForm} <br/> {'Max: ' + maxDateForm}</p>)
      }
      else{
        setWarningMsg("");
        setCalendarMinMax(prev=>({...prev, selected: e.target.value}));
        dateChanged.current = 1;
        if(type === 'key'){
          setShowCalendar(false);
        }
      }
  
        
        
    } catch (err) {
      console.log(err);
    }
  }

  function resetCreateScheduleFields () {
    try{
      setCreateSchDetails({name: '', time: '', extra: '', days: {mon: false, tue: false, wed: false, thurs: false, fri: false, sat: false, sun: false}});
      setAddSchToggleOptions({recurring: false, popup: false, active: true});
      setShowAddScheduleDisplay(false);
      setMultiSelectValuesSelected({drivers: [], vehicles: [], zones: [], attributes: []});
      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{selectedValues:[]}});
    } catch(err){console.log(err);}
  }
  

  return (
    <>
      {isLoading && (
        //////////////////////////
        // loading page spinner //
        //////////////////////////
        <span
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
        >
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            aria-busy= {isLoading}
            style={{ marginBottom: '3px' }}
          />
          
          <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>Please wait, Loading Data....</output></label>
        </span>
      )}
      
      { //////////////////////
        // "header" on page //
        //////////////////////
        <Row className="m-0 px-1" style={{backgroundColor:"#2e3942", height:"38px", maxHeight:"38px"}}>
          <Col className="d-flex my-auto align-items-center">
            <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none m-0' style={{maxWidth:"200px", maxHeight:"30px"}} alt="ITCurves" />
            <p className="fw-bold text-white text-center text-nowrap overflow-hidden h3 user-select-none flex-grow-1" style={{margin:"0"}}>
              {'Driver MDT Messaging 2.0'}
            </p>
          </Col>
        </Row>
      }


      <Row className="m-0 fw-normal user-select-none" style={{height:`calc(100vh - 83px)`}}>
        <Col xs={3}>
          <Row className="m-0" style={{maxHeight:"125px"}}>
            <Col className="border-bottom" style={{height: '125px', maxHeight:"125px"}}>
              {
                /////////////////////////
                // Affiliate Drop Down //
                /////////////////////////
                <select id="affiliateDrop" style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px"}} value={selectedAff}
                  onChange={(e)=>{setSelectedAff(e.target.value);}} 
                  className='text-center w-100 overflow-hidden callAgentInputStyle my-1' tabIndex={-1}
                >
                  {affiliateDropDownHTML}
                </select>
              }

              {
                ////////////////////////////
                // Driver Active 'Button' //
                ////////////////////////////
                <span className={`${driverStatusFlag === 'Active' ? 'text-white bg-dark' : ''} small px-2 mt-1 py-1`} onClick={()=>{
                    setDriverStatusFlag('Active'); 
                  if(activeVehNo !== 'XXXX'){
                    setDriverCardMsgList([]);
                      setDriverBlockListActiveCheck(prev =>
                        prev.map((driver, ind) => {
                        if(driver && driver.deviceID === 'XXXX'){
                          indexRef.current = ind;
                          activeDriver.current = "BroadCast"
                          return {...driver, active: true};
                        }
                        else if (driver) {
                          return {...driver, active: false};
                        }
                        return driver;
                      })
                      );
                      setActiveVehNo('XXXX');
                      if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
                      setDriverCardMsgList([]);
                  }
                  }} 
                  style={{backgroundColor: `${driverStatusFlag === 'Active' ? '' : '#e6eef1'}`, 
                  color: `${driverStatusFlag === 'Active' ? '' : 'black'}`, cursor:'pointer', borderRadius: "10px"
                }}
                  >
                  {"Online"}
                </span>
              }
              
              {
                ///////////////////////////////
                // Driver Inactive 'Button' //
                //////////////////////////////
                <span className={`${driverStatusFlag === 'Inactive' ? 'text-white bg-dark' : ''} small ms-2 px-2 py-1`} onClick={()=>{
                    setDriverStatusFlag('Inactive');
                  if(activeVehNo !== 'XXXX'){
                    setDriverCardMsgList([]);
                    setDriverBlockListActiveCheck(prev =>
                      prev.map((driver, ind) => {
                      if(driver && driver.deviceID === 'XXXX'){
                        indexRef.current = ind;
                        activeDriver.current = "BroadCast"
                        return {...driver, active: true};
                      }
                      else if (driver) {
                        return {...driver, active: false};
                      }
                      return driver;
                    })
                    );
                      setActiveVehNo('XXXX');
                      if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
                    }
                  
                  }} 
                  style={{backgroundColor: `${driverStatusFlag === 'Inactive' ? '' : '#e6eef1'}`, 
                    color: `${driverStatusFlag === 'Inactive' ? '' : 'black'}`, cursor:'pointer', borderRadius: "10px"
                  }}
                  >
                  {"Offline"}
                </span>
              }

              
              <span className="d-inline-block ms-2 my-auto">
                {
                  ////////////////////
                  // "Create Group" //
                  ////////////////////
                  <span className="my-auto" style={{cursor:"pointer"}} title={(createGroupFlag ? "Cancel Group" : "Create Group")} 
                    onClick={(e)=>{setCreateGroupFlag(!createGroupFlag); 
                      if(!createGroupFlag){
                        clearTimeout(loadSmartDevicesRef.current);
                        setTimeout(() => {
                          groupNameFieldRef.current.focus();
                        }, 200);
                      }
                      else{
                        clearGroupDetails();
                      }
                    }}
                  >
                    <Icon className={`${createGroupFlag ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} my-auto`} 
                      style={{width:"25px", height:"25px"}} 
                      icon={(!createGroupFlag ? 'ic:baseline-group-add' : 'ic:baseline-group-off')}
                    /> 
                    
                  </span>
                  
                }
                <>
                  <span className="d-inline-block ms-2 my-auto" style={{cursor:"pointer"}} title={("Schedule & View Messages")} 
                      onClick={(e) => { 
                        if(WebMRMS_URL.current !== "" && loginData.vUserName !== "" && loginData.vPassword !== "")
                        {
                          let url = WebMRMS_URL.current + "WebMRMS/DSPC/SmartDeviceSchedulingList.aspx?hfSDIID=-1&username="+ loginData.vUserName +"&pass=" + loginData.vPassword +"";
                          setScheduleDialog({Display:true, URL:url});
                          //const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
                          //if (newWindow) newWindow.opener = null;
                        }
                      }
                    }
                  >
                    {/* Your new span content */}
                    <Icon className={`my-auto`} 
                      style={{width:"25px", height:"25px"}} 
                      icon={('material-symbols-light:schedule-outline')}
                    /> 
                  </span>
                </>
                
                {createGroupFlag ? 
                  //////////////////////////////////
                  // "Create Group" button pop up //
                  //////////////////////////////////
                  <span className="position-absolute rounded text-center bg-white border border-secondary my-auto"
                    style={{width:'350px', maxWidth:'350px', height:'150px', maxHeight:'200px', top:'10%', zIndex: 1000}}
                  >
                    <p className='m-0 ms-1 d-block user-select-none my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                      style={{minWidth:"70px", textOverflow:'ellipsis'}}
                    >
                      {'Group Name:'}
                    </p>
                    <input type={"text"} ref={groupNameFieldRef} className="text-nowrap p-0 px-1 callAgentInputStyle" style={{maxHeight:"30px", height:"30px"}} 
                      onChange={(e)=>{setGroupNameAssigned(e.target.value);}} value={groupNameAssigned}
                    />
                    
                    {/* <span className="d-flex mt-1" style={{height:"20px", width: '100%'}}>
                      <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {'Group By:'}
                      </p>
                    </span>
                    <select style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px", width: '189px'}} value={groupByFilter}
                      onChange={(e)=>{setGroupByFilter(e.target.value);}} 
                      className='text-center overflow-hidden callAgentInputStyle' tabIndex={-1}
                    >
                      <option value={"Drivers"}>{"Drivers"}</option>
                      <option value={"Vehicles"}>{"Vehicles"}</option>
                      <option value={"Zones"}>{"Zones"}</option>
                      <option value={"Attributes"}>{"Attributes"}</option>
                    </select> */ //ABOVE IS FOR REMOVAL OF GROUP BY FOR GROUP CREATION - LEFT FOR FUTURE USE
                    }


                    <span className="d-flex mt-1" style={{height:"20px", width: '100%'}}>
                      <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {groupByFilter + ":"}
                      </p>
                      {/* <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {'Vehicles:'}
                      </p> */}
                    </span>
                    <span className="d-flex justify-content-center text-center w-100" style={{height:"40px"}}>
                      <MultiSelectDropdown options={filterOptionsMap[groupByFilter].options} disablePreSelectedValues={true} 
                        SelectionChangeCallback={(e)=>{
                          GenericSelectCallback(e, groupByFilter.toLowerCase(), filterOptionsMap[groupByFilter].options, 
                            filterOptionsMap[groupByFilter].setOptions, setMultiSelectValuesSelected
                          );
                        }} FireSelectEventOnEveryItemChange={true}
                      />
                      
                    </span>
                    
                    <span className="my-auto d-flex text-end justify-content-end mt-1">
                      <span className="my-auto d-inline-flex" style={{cursor:"pointer"}} title={'Create'} 
                        onClick={addGroupOfDrivers}
                      >
                        <Icon className={`text-success my-auto`} style={{width:"20px", height:"20px"}} 
                          icon={"material-symbols:check-rounded"}
                        /> 
                        
                      </span>
                      <span className="my-auto ms-2 me-1 d-inline-flex" style={{cursor:"pointer"}} title={"Cancel"} 
                        onClick={(e)=>{
                          setCreateGroupFlag(false); 
                          clearGroupDetails();
                        }}
                      >
                        <Icon className={`text-danger my-auto`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={"codex:cross"}
                        /> 
                    
                      </span>
                    </span>
                  </span> 
                : ""}
              </span>
              <label className="d-flex">
                <input id='allMessageCheck' type='checkbox' className="d-inline-flex" defaultChecked={allMsgToDriverFlag.current} style={{cursor:'pointer'}} 
                  onChange={(e)=>{allMsgToDriverFlag.current = e.target.checked; dateChanged.current = 1;}} 
                />
                <p className='m-0 ms-1 d-inline-block user-select-none w-100 fw-normal small text-start text-nowrap overflow-hidden' 
                  style={{minWidth:"120px", textOverflow:'ellipsis'}}
                >
                  {'All Messages to Driver'}
                </p>
              </label>
              
              <input id='driverSearch' type={"text"} className="text-nowrap p-0 px-1 my-1 callAgentInputStyle w-100" style={{maxHeight:"30px", height:"30px"}} 
                placeholder="Search for driver..." onChange={handleFilterDrivers} value={driverFilterInput}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col className="overflow-auto callAgentSummaryScroller" style={{height:`calc(100vh - 210px)`}}>
              {driversBlockList.length > 0 ? driversBlockList
                .map((item, index)=>{
                  const id = item.id === -1 ? '' : ('\nNo.: ' + item.driverNo);
                  const VEHNO = item.vehID === -1 ? '' : (", Veh: " + item.vehNo + " (" + item.vehType + ")"); 
                  const DriverName = item.name;
                  
                  // "One" mode: single-select only, toggle and reset others (blink style: 'fancy-blink')
                  return(
                    <Button variant={item.blink ? 'warning' : 'transparent'} key={index} active={item.vehNo === activeVehNo} 
                      className={`border-0 rounded raised-button mt-1 w-100 MessagingDriverCardHover text-start d-flex 
                        ${item.vehNo === activeVehNo ? 'MessagingDriverCardActive':''}`
                      }
                      onClick={()=> {
                        indexRef.current = index;
                        if(messageInputRef.current){messageInputRef.current.focus();}
                        setActiveVehNo(prev => {
                          activeDriver.current = item.name;
                          if(prev === item.vehNo){
                            return prev;
                          }
                          else {
                            setDriverCardMsgList([]);
                            return item.vehNo;
                          }
                        });
                      }}
                      title={(item.group === '-1' ? (DriverName + id + VEHNO) : '')}
                    >
                      {item.group !== '-1' ? 
                        <span className="my-auto d-flex" title={DriverName}>
                          <Icon className={`text-dark my-auto text-start d-inline-flex`} style={{width:"20px", height:"20px", minHeight:'20px', minWidth: '20px'}} 
                            icon={(item.name !== 'BroadCast' ? "el:group" : 'mage:megaphone-a-fill')}
                          /> 
                        </span>
                      : ""}
                      <p className={`m-0 ms-1 ${item.group !== '-1' ? 'd-inline-block flex-grow-1' : 'd-block flex-grow-1'} 
                          user-select-none my-auto fw-bold small text-start text-nowrap overflow-hidden`
                        } title={(item.group === '-1' ? '' : DriverName)}
                        style={{minWidth:(item.group !== '-1' ? '' : "70px"), width: (item.group !== '-1' ? '180px' : ""), textOverflow:'ellipsis'}}
                      >
                        {item.group === '-1'?
                          <>
                              <img src={'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp'} 
                                className={`rounded-circle float-start me-2 mt-1 border ${item.activeDriver? 'border-success' : 'border-danger'} 
                                  MessagingBorderWidthThickness`} 
                                style={{height:"35px", width:"35px"}} 
                                onError={(e)=>{
                                  e.target.src = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp';
                                }}
                                alt={'Profile'}
                              /> 
                              
                              <span className="d-block overflow-hidden text-nowrap" style={{ textOverflow: 'ellipsis' }}>
                                {DriverName + " (" + item.driverNo + ")"}
                              </span>
                              <span className="d-block overflow-hidden text-nowrap my-auto" style={{ textOverflow: 'ellipsis', marginLeft:'40px'}}>
                                <Icon className={`text-start d-inline-block me-1 mb-1`} style={{width:"20px", height:"20px", color: (item.blink ? 'black' : 'orange')}} 
                                  icon={"mdi:taxi"}
                                />  
                                {item.vehNo + " " + "(" + item.vehType + ")"}
                              </span>
                          </>
                        : (DriverName)}
                      </p>
                      {item.group !== '-1' && item.name !== 'BroadCast' ? 
                        <>
                          <span className={`my-auto d-inline-flex m-0 ms-2 me-1 float-end rounded-circle`}
                            title={"Delete Group"} onClick={(e)=>{deleteSelectedGroup(item);}}
                          >
                            <Icon className={`text-danger my-auto`} style={{width:"25px", height:"25px"}} icon={"codex:cross"}/>
                          </span>
                          
                          {/*
                            <span className={`my-auto d-inline-flex me-1 p-1 float-end rounded-circle`}
                              title={"Edit Group"} onClick={(e)=>{editSelectedGroup(item);}}
                            >
                              <Icon className={`text-secondary my-auto`} style={{width:"20px", height:"20px"}} icon={"mdi:gear-outline"}/>
                            </span> 
                          */ //ABOVE IS FOR REMOVAL OF GROUP EDIT - LEFT FOR FUTURE USE
                          }
                          
                          <span className={`my-auto d-inline-flex p-1 float-end rounded-circle`} ref={(el)=>(spanPopupRef.current[index] = el)}
                            onClick={(e)=>{handlePopupView(true, item, index);}} onMouseLeave={(e)=>{
                              setTimeout(() => {
                                handlePopupView(false, item, index);
                              }, 200);
                            }}
                          >
                            <Icon className={`text-info my-auto`} style={{width:"20px", height:"20px"}} icon={"material-symbols:info-outline-rounded"}/>
                          </span>
                        </>
                        
                      : ""}
                    </Button>
                  );
                }) 
              : ''}
              {showPopup.show && popupDriversList.length > 0 ? 
                <span className="position-absolute p-1 pb-2 text-start rounded-bottom bg-light raised-button" 
                  style={{top:popupPos.top, left:popupPos.left, zIndex: 1000}}
                >
                  {popupDriversList.map((item, index)=> {
                    return(
                      <p key={index} className="m-0 px-1 d-flex small text-nowrap" style={{height:'20px', width: 'auto'}}>
                        {'◆ ' } <b>{item.DriverNo}</b> {/* + item.FirstName + ' ' + item.LastName + ' (' {') '} */}
                        <span className="my-auto d-inline-flex ms-1" style={{cursor:"pointer"}}>
                          {/* <Icon className={`text-warning my-auto`} style={{width:"20px", height:"20px"}} 
                            icon={"mdi:taxi"}
                          />  */}
                          {/* {" " + " (SEDAN)"} */}
                        </span>
                      </p>
                    );
                  })}
                </span>
              :""}
            </Col>
          </Row>
          
        </Col>
        <Col xs={9} className="p-0" style={{height:`calc(100vh - 83px)`}} ref={msgListRef}>
          <select className='text-center mx-auto p-1 callAgentInputStyle raised-button messagingDateRangeSelect position-absolute justify-content-center d-flex' 
            style={{width: '173px', minWidth:"173px", maxHeight:"30px", height:"30px", zIndex:(openMsgScheduleView ? '' : 9999)}} value={givenDateRange}
            onChange={handleDateRangeChange} onClick={(e)=>{
              if(e.target.value === givenDateRange && givenDateRange === 'jump to specific date'){
                setShowCalendar(true); 
                // setTimeout(() => {
                //   if(calendarInputRef.current){
                //     calendarInputRef.current.focus();
                //   }
                // }, 200);
              }
            }} 
            ref={dateSelectRef}
          >
            <option value={"today"}>{"Today"}</option>
            <option value={"yesterday"}>{"Yesterday"}</option>
            <option value={"last week"}>{"Last week"}</option>
            <option value={"last month"}>{"Last month"}</option>
            <option value={"jump to specific date"}>
              {(calendarMinMax.selected && calendarMinMax.selected !== '' && warningMsg === '' ? 
                (calendarMinMax.selected.split("-")[1] + "/" + calendarMinMax.selected.split("-")[2] + "/" + calendarMinMax.selected.split("-")[0]) 
                : 
                "Go to a specific date"
              )}
            </option>
          </select>
          {showCalendar ? 
            <>
              <span className="d-block user-select-none bg-white rounded raised-button text-center my-auto position-absolute p-1" 
                style={{top:calendarPos.top, left:calendarPos.left, zIndex: 1000, width: '150px'}} ref={calendarSpanRef}
              >
                <input type="date" autoComplete="new_pass" ref={calendarInputRef} value={calendarMinMax.selected}
                  onChange={(e)=>{setCalendarMinMax(prev=>({...prev, selected: e.target.value}));}} 
                  onKeyDown={(e)=>{
                    if(e.key === 'Enter' && e.target.value !== ''){
                      e.preventDefault();
                      setCalendarMinMax(prev=>({...prev, selected: e.target.value}));
                      dateCheck(e, 'key');
                    } 
                  }} onBlur={(e)=>{if(e.target.value !== ''){setCalendarMinMax(prev=>({...prev, selected: e.target.value}));dateCheck(e, 'key');}}}
                  className="m-0 px-1 text-center callAgentInputStyle" min={calendarMinMax.min} max={calendarMinMax.max}
                  style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} 
                />
                <span className="my-auto d-block w-100 text-center text-danger mt-1">
                  {warningMsg}
                </span>
              </span>
            </>
          : ""}
          <MainContainer className="">
            <ChatContainer>
              {driversBlockList.length > 0 ? ( () => {
                const driverWithBlink = driversBlockList.find(card=>card.blink);
                  return driverWithBlink && blinkRecentMsg !== '' ? 
                  (
                    <ConversationHeader key={driverWithBlink.id}>
                      <ConversationHeader.Content
                        userName="Recent:"
                        info={blinkRecentMsg}
                      />
                    </ConversationHeader>
                  ) : <ConversationHeader key="noBlinks"></ConversationHeader>;
                })
              : <ConversationHeader key="noBlinks"></ConversationHeader>}
              
              <MessageList className="mt-4">
                { 
                messagesLoading ? (
                  <MessageList.Content>
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 999,
                    }}
                  >
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      aria-busy= {isLoading}
                      style={{ marginBottom: '3px' }}
                    />
                      <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>Please wait, Loading Data....</output></label>
                  </span>
                  </MessageList.Content>
                ) : driverCardMsgList?.msgList?.length === 0 ? 
                (
                  <MessageList.Content>
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 999,
                    }}
                  > 
                    <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>No Messages Found</output></label>
                  </span>
                  </MessageList.Content>
                ) :
                  (!Array.isArray(driverCardMsgList) && driverCardMsgList && driverCardMsgList.msgList ?
                  driverCardMsgList.msgList
                    .map((item, index) => {
                      // Get the color for the current sender from the pre-generated map
                      const bgColor = senderColorMap.get(item.msgFrom);
                      const uniqueClass = `sender-${item.msgFrom.replace(/[^a-zA-Z0-9]/g, '')}`;
          
                      const msgKey = String(driverCardMsgList.driverName) !== String(item.msgFrom);
                      const msgVal = item.msgString;
                      const hasPV = /\^PV|\^P|\^V/.test(msgVal);
                      const cleanedMsg = msgVal.replace(/\^PV|\^P|\^V/g, '').trim();
                      const direction = msgKey ? 'outgoing' : 'incoming';
                      const cleanedDateTime = (item.msgTime ? item.msgTime.replace(/[\sT]+/g, ' ').trim() : '');
                      const DateExtracted = (cleanedDateTime !== '' ? cleanedDateTime.split(' ')[0]: '');
                      const cleanedDateVal = (item.msgTime ? DateExtracted.split('-')[1]+"/"+DateExtracted.split('-')[2]+"/"+DateExtracted.split('-')[0] : '');
                      const timeArr = cleanedDateTime !== '' && cleanedDateTime.split(" ")[1].includes(':') ? cleanedDateTime.split(" ")[1].split(":") : [];
                      const timeFormatted = timeArr.length > 0 ? timeArr[0] + ":" + timeArr[1] : '';
                      const sentTimeVal = (givenDateRange.toLowerCase() === 'today' ? timeFormatted : cleanedDateVal + ' ' + timeFormatted);
                      let includedMsgType = '';

                      var styleEl = document.createElement('style');
                      styleEl.innerHTML = `
                                .${uniqueClass} .cs-message__content {
                                  background-color: ${bgColor};
                                }
                              `;
                      document.head.appendChild(styleEl);

                      var styleEl2 = document.createElement('style');
                      styleEl2.innerHTML = `
                                .cs-message--outgoing .cs-message__sender-name {
                                  display: block !important;
                                }
                              `;
                      document.head.appendChild(styleEl2);
          
                      if(hasPV){
                        includedMsgType = (msgVal.includes('^PV') ? (' (❐ 🔈)'): msgVal.includes('^P') ? ' (❐)' : msgVal.includes('^V') ? ' (🔈)' : '');
                      }
                      if (allMsgToDriverFlag.current === true) {
                        return(
                            <Message
                              key={`${index}-${item.MessageID}`}
                              className={uniqueClass}
                              model={{
                                message: cleanedMsg,
                                sentTime: sentTimeVal,
                                direction: direction,
                                position: "single",
                                sender: item.msgFrom
                              }}
                              children={<Message.Header style={{fontSize:'smaller'}} sender={item.msgFrom} sentTime={sentTimeVal + includedMsgType}/>}
                            />
                        )
                      }
                      else{
                        return (
                          <Message
                            key={`${index}-${item.MessageID}`}
                            model={{
                              message: cleanedMsg,
                              sentTime: sentTimeVal,
                              direction: direction,
                              position: "single",
                              sender: item.msgFrom
                            }}
                            children={<Message.Header style={{fontSize:'smaller'}} sender={item.msgFrom} sentTime={sentTimeVal + includedMsgType}/>}
                          />
                        )
                      }
                      
                    })
                    : ""
                )}
                
              </MessageList>

              <div as={MessageInput}>
                

                {chatType === 'chat' ?
                ////////////////////////// 
                // Normal chat selected //
                //////////////////////////
                  <>
                    <MessageInput autoFocus ref={messageInputRef} placeholder="Type message here..." attachButton={false} onSend={handleMsgSent}/>
                    <span className='float-end text-end my-auto mb-1 me-1 d-inline-flex' style={{cursor:"pointer"}} 
                      title={(sendMsgOptionsFlag.voice ? "Turn off voice message" : "Turn on voice message")} onClick={(e)=>{setSendMsgOptionsFlag(prev=>({...prev, voice:!prev.voice}));}}
                    >
                      <Icon className={`${sendMsgOptionsFlag.voice ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} mx-1 my-auto`} 
                        style={{width:"20px", minWidth:"20px", height:"20px"}} icon={(!sendMsgOptionsFlag.voice ? 'ion:volume-mute-outline': 'ion:volume-high-outline')}
                      /> 
                      
                    </span>
                    <span className='float-end text-end me-1 my-auto d-inline-flex' style={{cursor:"pointer"}} 
                      title={(sendMsgOptionsFlag.popup ? "Turn off popup message" : "Turn on popup message")} onClick={(e)=>{setSendMsgOptionsFlag(prev=>({...prev, popup:!prev.popup}));}}
                    >
                      <Icon className={`${sendMsgOptionsFlag.popup ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} my-auto`} 
                        style={{width:"20px", minWidth:"20px", height:"20px"}} icon={(!sendMsgOptionsFlag.popup ? 'material-symbols-light:select-window-off' : 'material-symbols:select-window')}
                      /> 
                    </span>
                  </>
                :
                ///////////////////////////
                // Special chat selected //
                ///////////////////////////
                  <>
                    <Row className="m-0 border-top">
                      <Col className="mt-1">
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtSpecialMsgTitle"
                          rows={1}
                          cols={20}
                          onKeyDown={(e)=>{

                          }}
                          placeholder="Enter a title..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtSpecialMsgTitle"
                          style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                          value={specialMsgDetails.title} onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, title: e.target.value}));}}
                          className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                        />
                      </Col>
                    </Row>
                    <Row className="m-0 my-1">
                      <Col>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtSpecialMsgBody"
                          rows={4}
                          cols={20}
                          onKeyDown={(e)=>{

                          }}
                          placeholder="Enter a message..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtSpecialMsgBody"
                          style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                          value={specialMsgDetails.body} onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, body: e.target.value}));}}
                          className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                        />
                      </Col>
                    </Row>
                    <Row className="m-0 mb-1">
                      <Col className="d-flex justify-content-end my-auto">
                        {/* <Button variant="info" tabIndex={0} className="me-2 my-auto rounded-circle d-inline-flex text-center justify-content-center" 
                          style={{ borderRadius: "0px", height:'35px', maxHeight:'35px', width:'35px', maxWidth:'35px'}} title={"Refresh special message history"}
                          onClick={refreshSpecialMsgHistory}
                        >
                          <Icon className={'text-white m-auto text-center'} style={{width:"20px", minWidth:"20px", height:"20px", minHeight:'20px'}} 
                            icon={'flowbite:refresh-outline'}
                          />
                        </Button> */}
                        <select className='text-center callAgentInputStyle raised-button my-auto me-2 messagingDateRangeSelect d-inline-flex' 
                          style={{minWidth:"120px", maxHeight:"30px", height:"30px", backgroundColor: '#c7e3f9'}} value={specialMsgDetails.option}
                          onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, option: e.target.value}));}}
                        >
                          <option value={"OK"}>{"OK"}</option>
                          <option value={"OK/Cancel"}>{"OK/Cancel"}</option>
                          <option value={"Yes/No/Cancel"}>{"Yes/No/Cancel"}</option>
                        </select>
                        <Button tabIndex={0} className="border-0 my-auto rounded d-inline-block raised-button messagingBtnStyle" 
                          style={{ borderRadius: "0px", height:'35px', maxHeight:'35px'}} disabled
                          onClick={handleSendSpecialMsg}
                        >
                          {"Send"}
                        </Button>
                      </Col>
                    </Row>
                  </>
                }
              </div>
            </ChatContainer>
          </MainContainer>
        </Col>
      </Row>
      {
        //////////////////////////////////////
        // Footer with Special/Chat options //
        //////////////////////////////////////
        <Row className="m-0 p-1 page-footer fixed-bottom" style={{backgroundColor:"#2e3942", height:'45px', maxHeight:'45px'}}>
          <Col className="text-end my-auto">
            
            
              {/* <p className='m-0 mx-1 my-auto text-white px-1 fw-bold float-end bg-light HeaderAlertResponsive shadow user-select-none d-flex messagingToggleShadow' 
                style={{borderRadius:"20px", height:'38px', maxHeight:'38px'}}
              >
                <Button variant="secondary" tabIndex={0} className={`messagingToggleBtn ${chatType ==='special' ? 'active': ''} border-0 small my-auto raised-button`} 
                  onClick={()=>{setChatType('special');}}
                >
                  {"Special"}
                </Button>
                <Button variant="secondary" tabIndex={0} className={`messagingToggleBtn ${chatType ==='chat' ? 'active': ''} ms-2 border-0 small my-auto raised-button`} 
                  onClick={()=>{setChatType('chat'); setSpecialMsgDetails({title:'', body: '', option: 'OK'});}}
                >
                  {"Chat"}
                </Button>
              </p> */}
            
            
            {/* 
              <Button variant="secondary" tabIndex={0} className="mx-1 rounded" style={{ borderRadius: "0px", height:'38px', maxHeight:'38px'}} 
                onClick={()=>{setOpenMsgScheduleView(true); setCreateGroupFlag(false);}}
              >
                {"Schedule"}
              </Button> */ //ABOVE IS FOR REMOVAL OF SCHEDULED MESSAGES - LEFT FOR FUTURE USE
            }
          </Col>
        </Row>}
      {//////////////////////
       // Schedule Message //
       //////////////////////
        openMsgScheduleView ? 
        <Modal centered backdrop="static" keyboard={true} size={"lg"} onHide={()=>{setOpenMsgScheduleView(false); setShowAddScheduleDisplay(false);}} 
          show={openMsgScheduleView} animation={true}
        >
          <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
            <Modal.Title style={{fontSize:"20px"}}>{"Schedule View"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            <Row className={`m-0`}>
              <Col className={`p-0 ${showAddScheduleDisplay ? 'd-none' : ''}`}>
                <GridControl ShowLoader={showLoader} ReloadDataFunction={(e)=>{}} 
                  Data={msgSchGridData} options={MsgSchGridOptions}
                /> 
              </Col>
              <Col className={`p-0 ${showAddScheduleDisplay ? '' : 'd-none'}`}>
                <Row>
                  <Col className="" xs={6}>
                    <span className="d-flex my-auto">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Schedule Name"}
                      </p>
                      <input type={"text"} className="text-nowrap p-0 px-1 callAgentInputStyle d-inline-flex" 
                        style={{maxHeight:"30px", height:"30px", width:'189px', minWidth:'189px'}} 
                        onChange={(e)=>{setCreateSchDetails(prev=>({...prev, name: e.target.value}));}} value={createSchDetails.name}
                      />
                    </span>
                    <span className="d-flex my-auto mt-1">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Driver(s)"}
                      </p>
                      <MultiSelectDropdown options={DriversFilterMultiSelect} disablePreSelectedValues={true} 
                        SelectionChangeCallback={(e)=>{
                          GenericSelectCallback(e, 'drivers', DriversFilterMultiSelect, 
                            SetDriversFilterMultiSelect, setMultiSelectValuesSelected
                          );
                        }} FireSelectEventOnEveryItemChange={true}
                      />
                    </span>
                    <span className="d-flex my-auto mt-1">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Time"}
                      </p>
                      <input type={"time"} className="text-nowrap justify-content-center p-0 px-1 callAgentInputStyle d-inline-flex text-center m-0" 
                        style={{maxHeight:"30px", height:"30px", width:'189px', minWidth:'189px'}} 
                        onChange={(e)=>{setCreateSchDetails(prev=>({...prev, time: e.target.value}));}} value={createSchDetails.time}
                      />
                    </span>
                  </Col>
                  <Col xs={6}>
                    <span className="d-flex my-auto mt-1">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Monday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.mon} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, mon:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Tuesday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.tue} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, tue:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Wednesday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.wed} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, wed:e.target.checked}}));}}
                        />
                      </span>
                      
                    </span>
                    <span className="d-flex my-auto">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Thursday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.thurs} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, thurs:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Friday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.fri} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, fri:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Saturday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.sat} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, sat:e.target.checked}}));}}
                        />
                      </span>
                    </span>
                    <span className="d-flex my-auto">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Sunday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.sun} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, sun:e.target.checked}}));}}
                        />
                      </span>
                    </span>
                    <span className="d-flex my-auto mt-1" style={{width:'120px', borderRadius:'4px'}}>
                      <span className="d-inline-flex my-auto ms-1" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, recurring:!prev.recurring}));}}
                        title={addSchToggleOptions.recurring ? 'Turn off recurring status' : 'Turn on recurring status'}
                      >
                        <Icon className={`my-auto ${addSchToggleOptions.recurring ? 'text-success' : 'text-secondary'}`}
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.recurring ? 'mdi:calendar-sync' : 'lucide:calendar-x-2')}
                        /> 
                      </span>
                      <span className="d-inline-flex my-auto ms-4" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, popup:!prev.popup}));}} 
                        title={addSchToggleOptions.popup ? 'Turn off popup status' : 'Turn on popup status'}
                      >
                        <Icon className={`my-auto ${addSchToggleOptions.popup ? 'text-success' : 'text-secondary'}`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.popup ? 'material-symbols:select-window' : 'material-symbols-light:select-window-off')}
                        /> 
                      </span>
                      <span className="d-inline-flex my-auto ms-4" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, active:!prev.active}));}} 
                        title={addSchToggleOptions.active ? 'Turn off active status' : 'Turn on active status'}
                       >
                        <Icon className={`my-auto ${addSchToggleOptions.active ? 'text-success' : 'text-secondary'}`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.active ? 'mdi:account-badge' : 'mdi:account-cancel')}
                        /> 
                      </span>
                    </span>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <textarea
                      name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtExtraCreateSch"
                      rows={4}
                      cols={20}
                      onKeyDown={(e)=>{

                      }}
                      placeholder="Enter a schedule message..."
                      id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtExtraCreateSch"
                      style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                      value={createSchDetails.extra} onChange={(e)=>{setCreateSchDetails(prev=>({...prev, extra: e.target.value}));}}
                      className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                    />
                  </Col>
                </Row>
              </Col>
            </Row> 
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="warning" tabIndex={0} className={`border-0 small my-auto raised-button ${showAddScheduleDisplay ? 'd-none' : ''}`} 
              onClick={()=>{}}
            >
              {"Refresh Grid"}
            </Button>
            <Button variant="secondary" tabIndex={0} className={`border-0 small my-auto raised-button ${showAddScheduleDisplay ? '' : 'd-none'}`} 
              onClick={()=>{resetCreateScheduleFields();}}
            >
              {"Close"}
            </Button>
            <Button variant="dark" tabIndex={0} className={`border-0 small my-auto raised-button`} 
              onClick={(e)=>{
                const btnTxt = e.target.textContent.toLowerCase();
                if(btnTxt.includes('add')) {setShowAddScheduleDisplay(true);}
                else { 
                  //Create Schedule View
                  resetCreateScheduleFields();
                }
              }}
            >
              {(showAddScheduleDisplay ? "Create Schedule" : "Add Schedule")}
            </Button>
          </Modal.Footer>
        </Modal>
      : ""}
      
          <Modal show={scheduleDialog.Display} centered backdrop="static" keyboard={true} size={"xl"} animation={true} 
            onHide={
              (e) => setScheduleDialog(prev => ({ ...prev, Display: false, URL: "" }))
            }>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 dispatch_action_dialog_header_bgcolor' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>{scheduleDialog.isLoading ? "Preparing Schedule..." : "Schedule & View Messages"}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 0, position: 'relative', minHeight: '550px' }}>
               {scheduleDialog.isLoading && (
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(255,255,255,0.9)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000
                }}>
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">Authenticating and loading schedule...</p>
                </div>
              )}
              <iframe src={scheduleDialog.URL} title="Embedded Content" width="100%" height="575px" 
              style={{ 
                border: 'none',
                visibility: scheduleDialog.isLoading ? 'hidden' : 'visible'
              }}
              onLoad={() => {
                // This fires when iframe content is fully loaded
                setScheduleDialog(prev => ({ ...prev, isLoading: false }));
              }}/>
            </Modal.Body>
          </Modal>
       
    </>
  );

}


export default Messaging;